<template>
  <div class="container package">
    <section id="editContent" class="columnContainer">
      <div class="innerColumn">
        <h1 class="contentTitle">{{locale.collection}}</h1>
        <div class="collectionLists">
          <div class="listGrid">
            <button type="button" class="item addItem" @click="openCreateCollectionPage = true"></button>
            <div
              v-for="(item, index) in list"
              :key="index"
              class="item"
              @click="setDetail(item.pageId)">
              <div
                class="name">
                {{ item.pageName }}
              </div>
              <div class="info">
                <p>{{ locale.table_createat }}: {{ dateFormat(item.createat) }}</p>
                <p>{{ locale.table_updateat }}: {{ dateFormat(item.updateat) }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <CreatePage
      v-if="openCreateCollectionPage"
      :locale="locale"
      @close="openCreateCollectionPage = false" />
  </div>
</template>

<script>
import DATE from '@/common/date'
import CreatePage from './CreatePage' 

export default {
  name: 'CollectionList',
  props: [
    'locale'
  ],
  components: {
    CreatePage
  },
  computed: {
  },
  created () {
    this.init()
  },
  data () {
    return {
      list: [],
      openCreateCollectionPage: false
    }
  },
  methods: {
    async init () {
      this.$store.commit('onLoading', true)
      await this.$store.dispatch('admin/getCodes')
      await this.getCollectionPageList()
      this.$store.commit('onLoading', false)
    },
    async getCollectionPageList () {
      const res = await this.$store.dispatch('collection/getCollectionPageList')
      const pageList = res?.message?.pageList
      if (pageList) {
        this.list = pageList
      }
      return res
    },
    dateFormat (isoString) {
      return DATE.toString(isoString)
    },
    setDetail (pageId) {
      this.$router.push({
        name: 'collectionPage',
        params: {
          pageId: pageId
        }
      })
    }
  }
}
</script>
